module.exports = __webpack_public_path__ + "static/media/beach2381.838a7ee0.jpg";